export const longToTimestamp = (timestamp) => {
  const date = new Date(timestamp)
  const day = String(date.getUTCDate()).padStart(2, '0')
  const month = String(date.getUTCMonth() + 1).padStart(2, '0')
  const year = date.getUTCFullYear()
  const hours = String(date.getUTCHours()).padStart(2, '0')
  const minutes = String(date.getUTCMinutes()).padStart(2, '0')
  const seconds = String(date.getUTCSeconds()).padStart(2, '0')

  return `${day}-${month}-${year} ${hours}:${minutes}:${seconds}`
}

export const isoToTimestamp = (isoString) => {
  if (isoString == null || isoString == undefined || isoString == '') return
  return isoString.split('T')[0] + ' ' + isoString.split('T')[1].split('.')[0]
}

export const formatDate = (dateString: string): string => {
  if (dateString == null || dateString == undefined || dateString == '')
    return ''
  const date = new Date(dateString)
  return date.toISOString()
}
export const formatDateForDisplay = (dateString: string): string => {
  if (dateString == null || dateString == undefined || dateString === '') {
    return 'N/A'
  }

  const date = new Date(dateString)

  if (isNaN(date.getTime())) {
    return 'Invalid Date'
  }

  const options: Intl.DateTimeFormatOptions = {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
  }

  return new Intl.DateTimeFormat('en-GB', options).format(date)
}

export const formatDateForDDMMMYYYY = (dateString: string): string => {
  if (!dateString) return 'N/A'
  const date = new Date(dateString)
  if (isNaN(date.getTime())) return 'Invalid Date'
  const day = date.getDate()
  const year = date.getFullYear()
  const months = [
    'Jan',
    'Feb',
    'Mar',
    'Apr',
    'May',
    'Jun',
    'Jul',
    'Aug',
    'Sept',
    'Oct',
    'Nov',
    'Dec',
  ]
  const month = months[date.getMonth()]
  return `${day} ${month} ${year}`
}

export const formatDateTimeToDDMMYYYY = (dateTimeString: string): string => {
  if (!dateTimeString) {
    return 'N/A'
  }

  let date: Date
  try {
    date = new Date(dateTimeString)

    if (
      isNaN(date.getTime()) &&
      dateTimeString.includes(' ') &&
      !dateTimeString.includes('T')
    ) {
      const isoLikeString = dateTimeString.replace(' ', 'T')
      date = new Date(isoLikeString)
    }

    if (isNaN(date.getTime())) {
      return 'Invalid Date'
    }

    const day = String(date.getDate()).padStart(2, '0')
    const month = String(date.getMonth() + 1).padStart(2, '0')
    const year = date.getFullYear()

    return `${day}-${month}-${year}`
  } catch (error) {
    console.error('Error formatting date:', error)
    return 'Error'
  }
}
